import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})

export class ProfileService {

  constructor(private http: HttpClient) { }

  getCustomerProfile(data: any): Observable<any> {
    const apiURL = `${environment.auth_url}/onboard/v1/fetch-byuser-onboarding`;
    return this.http.post<any>(apiURL, data);
  }

  EditBasicDetails(data: any): Observable<any> {
    const apiURL = `${environment.auth_url}/v1/edit-user`;
    return this.http.put<any>(apiURL, data);
  }

  getUserById(user_id: any): Observable<any> {
    const apiURL = `${environment.auth_url}/authorization/v1/get-user?iUserId=${user_id}`;
    return this.http.get(apiURL);
  }
}